<template>
  <div class="h-100 d-block">
    <vue-apex-charts
      type="area"
      :options="chartOptions"
      :series="series"
      width="100%"
      height="100%"
    />
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'AreaCharts',
  components: {
    VueApexCharts,
  },
  props: {
    seriesData: {
      type: Array,
      required: true,
    },
    categoriesData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          type: 'area',
          width: '100%',
          height: '100%',
          toolbar: {
            show: false,
          },
        },
        grid: {
          padding: {
            bottom: 20,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          position: 'top',
        },
        stroke: {
          curve: 'smooth',
          width: 2,
          show: true,
          lineCap: 'butt',
          colors: ['#FFC107', '#2196F3'],
          dashArray: 0,
        },
        colors: ['#FFC107', '#2196F3'],
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.25,
            opacityTo: 0.75,
            stops: [0, 90, 100],
          },
        },
        xaxis: {
          type: 'category',
          categories: [],
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy',
          },
          marker: true,
        },
      },
    }
  },
  watch: {
    seriesData: 'setData',
    categoriesData: 'setData',
  },
  created() {
    this.setData()
  },
  methods: {
    setData() {
      this.series = this.seriesData
      this.chartOptions.xaxis.categories = this.categoriesData
    },
  },
}
</script>
